module.exports = __webpack_public_path__ + "static/media/ru.09974d5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/ru.png
// module id = 345
// module chunks = 0